/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AccountsApiService, AdcsApiService, OrganisationsApiService } from '../../shared/http';
import { AddOrganisationComponent } from '../../shared/components/widgets/dashboard-widgets';
import { AuthGuard } from '../../../../core/guards';
import { CentraliseManagementSharedModule } from '../../shared/centraliseManagement.shared.module';
import { ExternalPageWrapperModule } from '../../../../pages/externalPageWrapper/external-page-wrapper.module';
import { ImageUploadComponent } from '../../shared/components/imageUpload/image-upload.component';
import { NgModule } from '@angular/core';
import { OnboardComponent } from './onboard.component';

/**
 *
 */
@NgModule({
    imports: [
        CentraliseManagementSharedModule,
        ExternalPageWrapperModule
    ],
    declarations: [
        AddOrganisationComponent,
        ImageUploadComponent,
        OnboardComponent,
    ],
    providers: [
        AccountsApiService,
        AuthGuard,
        AdcsApiService,
        OrganisationsApiService
    ]
})

export class OnboardModule {
}
